/* global _gaq, ga */
/*
 Example:
 ga_event({
 "category": "mobile nav",
 "action": "click",
 "label": "opened",
 "value": 1
 });
 */
function ga_event(event_object, callback) {
	//gaq version
	if(typeof _gaq != "undefined") {
		_gaq.push(['_trackEvent', event_object.category, event_object.action, event_object.label, event_object.value], function() {	
			if(typeof callback === "function") { callback(); }
		});
	//ga() version
	} else if(window.ga && ga.create) {
		ga('send', 'event', {
			'eventCategory' : event_object.category,
			'eventAction'   : event_object.action,
			'eventLabel'    : event_object.label,
			'eventValue'    : event_object.value,
			'hitCallback'   : function () {
				if(typeof callback === "function") { callback(); }
			}
		});
	} else {
		if(typeof callback === "function") { callback(); }
	}	
}
function ga_track(c, a, l, v) {
  ga_event({category: c, action: a, label:l, value: v});
}